import React from "react";

import { Card, Divider } from "antd";
import { AddOutlined } from "@mui/icons-material";

import useQuestionsFormPresenter from "@Totum/QuestionnaireBuilder/Presentation//hooks/useQuestionsFormPresenter";

import { IItemRenderProps, SortableList } from "@Totum/Main/Components/shared/SortableList";

import DesignerRow from "@Totum/QuestionnaireBuilder/UI/components/DesignerRow";

import "@Totum/Main/Styles/components/designer.scss";

const QuestionsForm = () => {
    const { handlers, uiModel } = useQuestionsFormPresenter();

    return (
        <div className={"questionnaire-designer-item-list designer-item-list"}>
            <Divider />
            <SortableList
                items={uiModel.items}
                setItems={handlers.handleRearrangeRows}
                itemRender={({ item, index }: IItemRenderProps) => (
                    <DesignerRow
                        index={index}
                        key={`${uiModel.questionnaireId}_${item?.questionId}`}
                        questionId={item.id}
                    />
                )}
            />
            {uiModel.canAddRow ? (
                <div className={"designer-add-control"} onClick={handlers.handleAddRow}>
                    <AddOutlined />
                </div>
            ) : null}
        </div>
    );
};

export default QuestionsForm;
